import * as BrandLogoConst from 'constants/BrandConst'
import { v4 as uuidv4 } from 'uuid'
import { isArrayNotEmpty, isObjectEmpty, searchFirstObjectInList } from './JSUtil'
import * as FormConst from '../constants/FormConst'
import {BRAND_SCANDINAVIAN_REGION} from "constants/BrandConst";

export const getBrandLogo = (hotelInfo) => {
    if (isObjectEmpty(hotelInfo)) {
        return null
    }

    function getLogoByBrandCode() {
        if (hotelInfo.address && hotelInfo.address.country !== 'US') {
            return BrandLogoConst.BRAND_LOGOS[BrandLogoConst.BRAND_TYPE_INTERNATIONAL][hotelInfo.brandCode]
        } else {
            return BrandLogoConst.BRAND_LOGOS[BrandLogoConst.BRAND_TYPE_DOMESTIC][hotelInfo.brandCode]
        }
    }

    function getLogoByBrandCodeAndProductCode() {
        let logoKeyName = hotelInfo.brandCode + '_' + hotelInfo.productCode
        if (hotelInfo.address && hotelInfo.address.country !== 'US') {
            return BrandLogoConst.BRAND_PRODUCT_LOGOS[BrandLogoConst.BRAND_TYPE_INTERNATIONAL][logoKeyName]
        } else {
            return BrandLogoConst.BRAND_PRODUCT_LOGOS[BrandLogoConst.BRAND_TYPE_DOMESTIC][logoKeyName]
        }
    }

    return getLogoByBrandCodeAndProductCode()
               ? getLogoByBrandCodeAndProductCode()
               : getLogoByBrandCode();
}

export const getTrackingId = () => {
    return uuidv4()
}

export const getRequestor = (user) => {
    return 'PROPEL_' + user['preferred_username'].split('@')[0]
}

export const isFormEnabled = (formEntry, onboardingStatusChecklist) => {
    if (isArrayNotEmpty(formEntry.current.dependencies) && isArrayNotEmpty(onboardingStatusChecklist)) {
        const result = formEntry.current.dependencies.every((dependency) => {
            const checklistEntry = searchFirstObjectInList('code', dependency, onboardingStatusChecklist)
            return checklistEntry?.processedFlag === 'COMPLETED'
        })
        return result
    }
    return true
}

export const getMinRoomsRequiredForBox = (boxName, isCambria) => {
    const minRoomRequired = isCambria && boxName === FormConst.BOX_NAME_EMPLOY
        ? FormConst.MIN_ROOMS_REQUIRED_BOX_CAMBRIA
        : FormConst.MIN_ROOMS_REQUIRED_BOX[boxName]
    return minRoomRequired || FormConst.MIN_ROOMS_REQUIRED_BOX_DEFAULT
}

export const isRoomTypeAccessible = (roomType) => {
    return roomType.accessible ? FormConst.ACCESSIBILITY_VALUES_LIST.includes(roomType.accessible) : false
}

export const isScandinavianProperty = (hotelInfo) => {
    return hotelInfo?.groupingTags[0]?.includes(BRAND_SCANDINAVIAN_REGION)
}